import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

const Root = lazy(() => import("../pages/Root"));
const Homepage = lazy(() => import("../pages/Homepage"));
const Neighbourhood = lazy(() => import("../pages/Neighbourhood"));
const Residences = lazy(() => import("../pages/Residences"));
const Floorplans = lazy(() => import("../pages/Floorplans"));
const Team = lazy(() => import("../pages/Team"));
const Register = lazy(() => import("../pages/Register"));
const Thankyou = lazy(() => import("../pages/Thankyou"));
const Privacy = lazy(() => import("../pages/Privacy"));

const routes = [
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        element: <Homepage />,
      },
      {
        path: "/neighbourhood",
        element: <Neighbourhood />,
      },
      {
        path: "/residences",
        element: <Residences />,
      },
      {
        path: "/floorplans",
        element: <Floorplans />,
      },
      {
        path: "/team",
        element: <Team />,
      },
      {
        path: "/register",
        element: <Register />,
      },
      {
        path: "/thankyou",
        element: <Thankyou />,
      },
      {
        path: "/privacy",
        element: <Privacy />,
      },
    ],
  },
];

const router = createBrowserRouter(routes);
export default router;
